let slidenum = 1;



$('.maf').click(function() {
 	 $('.cover').hide();
  $('.progbar').show();
  $('.numtop').show();
  $('.slide.one').show();
  });
 

$('.answer-incorrect').click(function() {
 	 $('.correctan').hide();
  $('.incorrect').show();
  });
 

$('.type-2').click(function() {
 	 $('.type-1').hide();
  $('.type-2').show();
  });

$('.type-3').click(function() {
 	 $('.type-1').hide();
  $('.type-3').show();
  });
 

$('.type-4').click(function() {
 	 $('.type-1').hide();
  $('.type-4').show();
  });
 

$('.type-5').click(function() {
 	 $('.type-1').hide();
  $('.type-5').show();
  });
 

$('.type-6').click(function() {
 	 $('.type-1').hide();
  $('.type-6').show();
  });
 

$('.type-7').click(function() {
 	 $('.type-1').hide();
  $('.type-7').show();
  });



$('.freq-1-but').click(function() {
 	 $('.freq-2, .freq-3, .freq-4, .freq-5').hide();
  $('.freq-1').show();
  });

 
$('.freq-2-but').click(function() {
 	 $('.freq-1, .freq-3, .freq-4, .freq-5').hide();
  $('.freq-2').show();
  });

$('.freq-3-but').click(function() {
 	 $('.freq-1, .freq-2, .freq-4, .freq-5').hide();
  $('.freq-3').show();
  });
 

$('.freq-4-but').click(function() {
 	 $('.freq-1, .freq-3, .freq-2, .freq-5').hide();
  $('.freq-4').show();
  });
 

$('.freq-5-but').click(function() {
 	 $('.freq-1, .freq-3, .freq-4, .freq-2').hide();
  $('.freq-5').show();
  });
 




$('.color.one').click(function() {
 	 $('.color-2, .color-3, .color-4, .color-5').hide();
  $('.color-1').show();
  });

 
$('.color.two').click(function() {
 	 $('.color-1, .color-3, .color-4, .color-5').hide();
  $('.color-2').show();
  });

$('.color.three').click(function() {
 	 $('.color-1, .color-2, .color-4, .color-5').hide();
  $('.color-3').show();
  });
 

$('.color.four').click(function() {
 	 $('.color-1, .color-3, .color-2, .color-5').hide();
  $('.color-4').show();
  });
 

$('.color.five').click(function() {
 	 $('.color-1, .color-3, .color-4, .color-2').hide();
  $('.color-5').show();
  });
 




$('.color').click(function() {
    var $group = $(this).closest('.colors');
    $('.color', $group).removeClass("active");
    $(this).addClass("active");
 	 $('.slide.one').fadeOut();
  $('.slide.two').delay(300).fadeIn();
  slidenum = slidenum + 1;
  document.getElementById("slidenum").innerHTML=slidenum;
  $(".progbar div").removeClass();
  $(".progbar div").addClass("bar two");
  });
 

$('.shape').click(function() {
    var $group = $(this).closest('.shapes');
    $('.shape', $group).removeClass("active");
    $(this).addClass("active");
 	 $('.slide.two').fadeOut();
  $('.slide.three').delay(300).fadeIn();
    slidenum = slidenum + 1;
  document.getElementById("slidenum").innerHTML=slidenum;
    $(".progbar div").removeClass();
  $(".progbar div").addClass("bar three");
  });

$('.three .button').click(function() {
    var age = $(this).attr('value');
  $('.displayage').html(age);
  
  var $group = $(this).closest('.buttons');
    $('.button', $group).removeClass("active");
  
    $(this).addClass("active");
 	 $('.slide.three').fadeOut();
  $('.slide.four').delay(300).fadeIn();
      slidenum = slidenum + 1;
  document.getElementById("slidenum").innerHTML=slidenum;
      $(".progbar div").removeClass();
  $(".progbar div").addClass("bar four");
  });


$('.four .button').click(function() {
    var $group = $(this).closest('.buttons');
    $('.button', $group).removeClass("active");
    $(this).addClass("active");
 	 $('.slide.four').fadeOut();
  $('.slide.five').delay(300).fadeIn();
      slidenum = slidenum + 1;
  document.getElementById("slidenum").innerHTML=slidenum;
      $(".progbar div").removeClass();
  $(".progbar div").addClass("bar five");
  });


$('.five .button').click(function() {
    $( this ).toggleClass( "active" );
 	 $('.slide.four').fadeOut();
  $('.slide.five').delay(300).fadeIn();
  });

$('.five .button.continue').click(function() {
    $( this ).toggleClass( "active" );
 	 $('.slide.five').fadeOut();
  $('.slide.eleven').delay(600).fadeIn();
      slidenum = slidenum + 1;
  document.getElementById("slidenum").innerHTML=slidenum;
      $(".progbar div").removeClass();
  $(".progbar div").addClass("bar eleven");
  });


$('.six .button').click(function() {
    var $group = $(this).closest('.buttons');
    $('.button', $group).removeClass("active");
    $(this).addClass("active");
 	 $('.slide.six').fadeOut();
  $('.slide.eleven').delay(300).fadeIn();
      slidenum = slidenum + 1;
  document.getElementById("slidenum").innerHTML=slidenum;
      $(".progbar div").removeClass();
  $(".progbar div").addClass("bar eleven");
  });


$('.seven .button.continue').click(function() {
    $( this ).toggleClass( "active" );
 	 $('.slide.seven').fadeOut();
  $('.slide.eight').delay(300).fadeIn();
      slidenum = slidenum + 1;
  document.getElementById("slidenum").innerHTML=slidenum;
      $(".progbar div").removeClass();
  $(".progbar div").addClass("bar eight");
  });


$('.eight .button').click(function() {
    var $group = $(this).closest('.buttons');
    $('.button', $group).removeClass("active");
    $(this).addClass("active");
 	 $('.slide.eight').fadeOut();
  $('.slide.nine').delay(300).fadeIn();
      slidenum = slidenum + 1;
  document.getElementById("slidenum").innerHTML=slidenum;
      $(".progbar div").removeClass();
  $(".progbar div").addClass("bar nine");
  });



$('.nine .button').click(function() {
    var $group = $(this).closest('.buttons');
    $('.button', $group).removeClass("active");
    $(this).addClass("active");
 	 $('.slide.nine').fadeOut();
  $('.slide.ten').delay(300).fadeIn();
      slidenum = slidenum + 1;
  document.getElementById("slidenum").innerHTML=slidenum;
      $(".progbar div").removeClass();
  $(".progbar div").addClass("bar ten");
  });



$('.ten .button').click(function() {
    var $group = $(this).closest('.buttons');
    $('.button', $group).removeClass("active");
    $(this).addClass("active");
 	 $('.slide.ten').fadeOut();
  $('.slide.eleven').delay(300).fadeIn();
      slidenum = slidenum + 1;
  document.getElementById("slidenum").innerHTML=slidenum;
      $(".progbar div").removeClass();
  $(".progbar div").addClass("bar eleven");
  });


$('.eleven .button').click(function() {
    var $group = $(this).closest('.buttons');
    $('.button', $group).removeClass("active");
    $(this).addClass("active");
 	 $('.slide.eleven').fadeOut();
  $('.slide.twelve').delay(300).fadeIn();
      slidenum = slidenum + 1;
  document.getElementById("slidenum").innerHTML=slidenum;
      $(".progbar div").removeClass();
  $(".progbar div").addClass("bar twelve");
  });



$('.twelve .button.continue').click(function() {
    $( this ).toggleClass( "active" );
    $('.progbar').hide();
    $('.numtop').hide();
 	 $('.slide.twelve').fadeOut();
  $('.qheader').fadeOut();
  $('#results').delay(300).fadeIn();
      slidenum = slidenum + 1;
  document.getElementById("slidenum").innerHTML=slidenum;
  });


$('#bmi-weight').change(function() {
  var weightNow = $(this).val();
  $('.displayweight').html(weightNow);
});

$('#bmi-weight-wish').change(function() {
  var weightWish = $('#weight').val();
  $('.displayweightwish').html(weightWish);
});

$('#bmi-height-ft').change(function() {
  var heightFt = $(this).val();
  $('.hfeet').html(heightFt);
});

$('#bmi-height').change(function() {
  var heightIn = $(this).val();
  $('.hinches').html(heightIn);
});

$('#bmi-imperial').click(function() {
  $('.imper').show();
    $('.feet-label').show();
  $('#bmi-height-ft').show();
  $('.metric').hide();
  $('.bmi-weight-unit').html(' LBS');
  $('.bmi-height-unit').html(' IN&nbsp;&nbsp;');
  $('.height input').toggleClass( "met" );
});

$('#bmi-metric').click(function() {
  $('.imper').hide();
  $('.feet-label').hide();
  $('#bmi-height-ft').hide();
  $('.metric').show();
  $('.bmi-weight-unit').html(' KG');
  $('.bmi-height-unit').html(' CM');
  $('.height input').toggleClass( "met" );
});


















$('.slide.one .goback').click(function() {
  	 $('.slide.one').fadeOut();
	 $('.cover').delay(300).fadeIn();
    $(".progbar div").removeClass();
  $(".progbar div").addClass("bar");
  });



$('.slide.two .goback').click(function() {
  	 $('.slide.two').fadeOut();
	 $('.slide.one').delay(300).fadeIn();
      slidenum = slidenum - 1;
  document.getElementById("slidenum").innerHTML=slidenum;
    $(".progbar div").removeClass();
  $(".progbar div").addClass("bar");
  });

$('.slide.three .goback').click(function() {
  	 $('.slide.three').fadeOut();
	 $('.slide.two').delay(300).fadeIn();
        slidenum = slidenum - 1;
  document.getElementById("slidenum").innerHTML=slidenum;
    $(".progbar div").removeClass();
  $(".progbar div").addClass("bar two");
  });

$('.slide.four .goback').click(function() {
  	 $('.slide.four').fadeOut();
	 $('.slide.three').delay(300).fadeIn();
        slidenum = slidenum - 1;
  document.getElementById("slidenum").innerHTML=slidenum;
    $(".progbar div").removeClass();
  $(".progbar div").addClass("bar three");
  });

$('.slide.five .goback').click(function() {
  	 $('.slide.five').fadeOut();
	 $('.slide.four').delay(300).fadeIn();
        slidenum = slidenum - 1;
  document.getElementById("slidenum").innerHTML=slidenum;
    $(".progbar div").removeClass();
  $(".progbar div").addClass("bar four");
  });

$('.slide.six .goback').click(function() {
  	 $('.slide.six').fadeOut();
	 $('.slide.five').delay(300).fadeIn();
        slidenum = slidenum - 1;
  document.getElementById("slidenum").innerHTML=slidenum;
    $(".progbar div").removeClass();
  $(".progbar div").addClass("bar five");
  });

$('.slide.seven .goback').click(function() {
  	 $('.slide.seven').fadeOut();
	 $('.slide.five').delay(300).fadeIn();
        slidenum = slidenum - 1;
  document.getElementById("slidenum").innerHTML=slidenum;
    $(".progbar div").removeClass();
  $(".progbar div").addClass("bar five");
  });

$('.slide.eight .goback').click(function() {
  	 $('.slide.eight').fadeOut();
	 $('.slide.seven').delay(300).fadeIn();
        slidenum = slidenum - 1;
  document.getElementById("slidenum").innerHTML=slidenum;
    $(".progbar div").removeClass();
  $(".progbar div").addClass("bar seven");
  });

$('.slide.nine .goback').click(function() {
  	 $('.slide.nine').fadeOut();
	 $('.slide.eight').delay(300).fadeIn();
        slidenum = slidenum - 1;
  document.getElementById("slidenum").innerHTML=slidenum;
    $(".progbar div").removeClass();
  $(".progbar div").addClass("bar eight");
  });

$('.slide.ten .goback').click(function() {
  	 $('.slide.ten').fadeOut();
	 $('.slide.nine').delay(300).fadeIn();
        slidenum = slidenum - 1;
  document.getElementById("slidenum").innerHTML=slidenum;
    $(".progbar div").removeClass();
  $(".progbar div").addClass("bar nine");
  });

$('.slide.eleven .goback').click(function() {
  	 $('.slide.eleven').fadeOut();
	 $('.slide.six').delay(300).fadeIn();
        slidenum = slidenum - 1;
  document.getElementById("slidenum").innerHTML=slidenum;
    $(".progbar div").removeClass();
  $(".progbar div").addClass("bar six");
  });

$('.slide.twelve .goback').click(function() {
  	 $('.slide.twelve').fadeOut();
	 $('.slide.eleven').delay(300).fadeIn();
        slidenum = slidenum - 1;
  document.getElementById("slidenum").innerHTML=slidenum;
    $(".progbar div").removeClass();
  $(".progbar div").addClass("bar eleven");
  });

$('.slide.thirteen .goback').click(function() {
  	 $('.slide.thirteen').fadeOut();
	 $('.slide.twelve').delay(300).fadeIn();
        slidenum = slidenum - 1;
  document.getElementById("slidenum").innerHTML=slidenum;
    $(".progbar div").removeClass();
  $(".progbar div").addClass("bar twelve");
  });


 $(document).ready(function () {
   if(window.location.href.indexOf("results") > -1) {
   $(".cover").hide();
    $(".results").show(); 
  }
});



function measureBMI () {
  // true = metric, false = imperial
  let unit = document.getElementById("bmi-metric").checked,
      weight = document.getElementById("bmi-weight"),
      weightu = document.getElementByClassName("bmi-weight-unit"),
      height = document.getElementById("bmi-height"),
	  heightft = document.getElementById("bmi-height-ft"),
      heightu = document.getElementById("bmi-height-unit");
	
  
  if (unit) {
    weightu.innerHTML = "KG";
    weight.min = 1;
    weight.max = 635;
    heightu.innerHTML = "CM";
    height.min = 54;
    height.max = 272;
  } else {
    weightu.innerHTML = "LBS";
    weight.min = 2;
    weight.max = 1400;
    heightu.innerHTML = "IN";
    height.min = 0;
    height.max = 11;
	heightft.min = 4;
    heightft.max = 8;
  }
}

function calcBMI () {
  // (A) Get elements
  let bmi = null,
      unit = document.getElementById("bmi-metric").checked, // true = metric, false = imperial
      weight = parseInt(document.getElementById("bmi-weight").value),
      height = parseInt(document.getElementById("bmi-height").value),
	  heightft = parseInt(document.getElementById("bmi-height-ft").value),
	  heightin = (heightft * 12) + height,
      results = document.getElementById("BMI"),
	  resultstext = document.getElementById("DESC"),
      wastebox = document.getElementById("waste"); 

  // (B) Calculate BMI
  // Metric BMI = Mass (kg) / Height (m) square 
  if (unit) {
    height = height / 100;
    bmi = weight / (height * height);
  }
  // Imperial BMI = 703 X Mass (lbs) / Height (in) square 
  else {
    bmi = 703 * (weight / (heightin * heightin));
  }
  // Round off
  bmi = Math.round(bmi); // Round off 2 decimal places

  // (C) Show Results
  if (bmi < 18.5) {
    results.innerHTML = bmi;
    resultstext.innerHTML = "Underweight";
  } else if (bmi < 25) {
    results.innerHTML = bmi;
    resultstext.innerHTML = "Normal weight";
  } else if (bmi < 30) {
    results.innerHTML = bmi;
    resultstext.innerHTML = "Pre-obesity";
  } else if (bmi < 35) {
    results.innerHTML = bmi;
    resultstext.innerHTML = "Obesity class I";
  } else if (bmi < 40) {
    results.innerHTML = bmi
    resultstext.innerHTML = "Obesity class II";
  } else {
    results.innerHTML = bmi;
    resultstext.innerHTML = "Obesity class III";
  }


    //  Show Waste Results
  if (weight < 119 ) {
    wastebox.innerHTML = "3";
  } else if (weight < 140) {
    wastebox.innerHTML = "5";
  } else if (weight < 160) {
    wastebox.innerHTML = "6";
  } else if (weight < 180) {
    wastebox.innerHTML = "7";
  } else if (weight < 200) {
    wastebox.innerHTML = "8";
  } else {
    wastebox.innerHTML = "10";
  }
  return false;


}

    
